import { takeLatest, put, call } from 'redux-saga/effects'
import * as actions from '../slices/index'
import Cgm from '../../api/cgm'
import constants from '../../constants'

const fetchCgmOnboardingLandingPageRequest =
  function* fetchCgmOnboardingLandingPageRequest({ payload }) {
    try {
      const response = yield call(Cgm.getCgmOnboardingLandingPage, payload)
      if (response?.code === '-1') {
        throw new Error('Session Expire')
      } else if (response?.code === '0') {
        throw new Error(response?.msg || 'Something went wrong')
      }

      yield put(actions.fetchCgmOnboardingLandingPageSuccess(response))
    } catch (error) {
      yield put(
        actions.fetchCgmOnboardingLandingPageError(
          error instanceof Error
            ? error?.message
            : constants.ERROR_MSG?.SOMETHING_WENT_WRONG ||
                'Something went wrong',
        ),
      )
    }
  }

const setCgmDeviceNameRequest = function* setCgmDeviceNameRequest({ payload }) {
  const { resolve, reject, ...apiPayload } = payload
  try {
    const response = yield call(Cgm.setCgmDeviceName, apiPayload)
    if (response?.code === '-1') {
      throw new Error('Session Expire')
    } else if (response?.code === '0') {
      throw new Error(response?.msg || 'Something went wrong')
    }

    yield put(actions.setCgmDeviceNameSuccess(response))
    if (resolve) resolve(response)
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error?.message
        : constants.ERROR_MSG?.SOMETHING_WENT_WRONG || 'Something went wrong'

    yield put(actions.setCgmDeviceNameError(errorMessage))
    if (reject) reject(error)
  }
}

export function* cgmSaga() {
  yield takeLatest(
    actions.fetchCgmOnboardingLandingPageRequest,
    fetchCgmOnboardingLandingPageRequest,
  )
  yield takeLatest(actions.setCgmDeviceNameRequest, setCgmDeviceNameRequest)
}
